import SecurityAwareness from "./SecurityAwareness";

export default SecurityAwareness;
